import urls from "../../api/urls.json";
import Loader from "../Loader";
import { useEffect, useRef, useState } from "react";
import { BaseButton, BottomButton } from "../../styles/ButtonStyles";
import { ImageCirlceView, ImageDivView } from "../../styles/ImageWrapper";
import { FlexWrapper, LineView, GapView } from "../../styles/WrapperStyles";
import styled, { css } from 'styled-components';
import placeholder_image from "../../assests/placeholder_image.png";
import { convertTimestampToFormattedDate, getProfileDOB, getDate, getDateWithTime, safeGetDateWithTime } from '../../utils'
import FeedDetailedProfileView from "./FeedDetailedProfileView";
import ProfileStateListModal from "../modals/ProfileStateListModal";
import LocationHistoryModal from "../modals/LocationHistoryModal";
import DeviceInfoModal from "../modals/DeviceInfoModal";
import ActivityModal from "../modals/ActivityModal";
import MessageModal from "../modals/MessageModal"
import TransferSubModal from "../modals/TransferSubModal";
import InvoicesModal from "../modals/InvoicesModal";
import InvitesModal from "../modals/InvitesModal";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import VerifyModal from "../modals/VerifyModal";
import '../styles/Member.css';
import CaptureGooglePaymentModal from "../modals/CaptureGooglePaymentModal";
import { capturePaymentPermission, invoiceModalAccess, gPlayAndSubTransferPermission } from "../../access_levels";
import OfflineInvoicesModal from "../modals/OfflineInvoicesModal";
import ProfileLogHistoryListModal from "../modals/ProfileLogHistoryListModal";
import ImageHistoryModal from "../modals/ImageHistoryModal";
import IncognitoHistoryModal from "../modals/IncognitoHistoryModal";
import BoostHistoryModal from "../modals/BoostHistoryModal";
import CuratorLogHistoryModal from "../modals/CuratorLogHistoryModal";
import SubscriptionsModal from "../modals/SubscriptionsModal";
import ExtendSubscriptionModal from "../modals/ExtendSubscriptionModal";
import MoneyBackGuaranteeModal from "../modals/MoneyBackGuaranteeModal";
import SparkPurchaseHistoryModal from "../modals/SparkPurchaseHistoryModal";


const HistoryBox = styled.div`
  color: black;
  cursor: pointer;
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  border: 2px solid #007bff;
  border-radius: 10px;
  padding: 5px 10px;
  margin-left: 50px;
  display: inline-block;
`;

const IncognitoHistoryBox = styled.div`
  color: black;
  cursor: pointer;
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  border: 2px solid #007bff;
  border-radius: 10px;
  padding: 5px 10px;
  margin-left: 20px;
  display: inline-block;
`;

const BoostHistoryBox = styled.div`
  color: black;
  cursor: pointer;
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  border: 2px solid #007bff;
  border-radius: 10px;
  padding: 5px 10px;
  margin-left: 50px;
  display: inline-block;
`;

const CuratorLogHistoryBox = styled.div`
  color: black;
  cursor: pointer;
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  border: 2px solid #007bff;
  border-radius: 10px;
  padding: 5px 10px;
  margin-left: 20px;
  display: inline-block;
`;

const ConnectedDiv = styled.div`
  margin-right: 20px;
  margin-top: 15px;
`;

const BottomButtonBase = styled(BottomButton)`
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FlexBottom = styled(FlexWrapper)`
  flex-flow: wrap;
  width: 800px;
`;

const InfoDiv = styled.div`
  width: 252px;
`;

const InfoText = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  ${props =>
        props.cursor &&
        css`
      cursor: pointer;
    `}
`;

const MetricText = styled(InfoText)`
  white-space: nowrap;
`;

const MbgUserLabel = styled.span`
  display: inline-block;
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #d9f7e8;
  color: #0f8a4b;
  border: 1px solid #86d7aa;
  font-family: 'Gilory-Semi';
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.3px;
`;

const SupportActionsWrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
`;

const SupportActionsButton = styled(BaseButton)`
  width: 220px;
`;

const DownloadAccountDataButton = styled(BaseButton)`
  width: 260px;
  margin-left: 20px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

const SupportActionsMenu = styled.div`
  position: absolute;
  top: 78px;
  left: 0;
  width: 300px;
  background-color: #ffffff;
  border: 1px solid #c4ccd3;
  border-radius: 18px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  z-index: 10;
`;

const SupportActionItem = styled.button`
  width: 100%;
  border: 0;
  border-bottom: 1px solid #dde3e8;
  background: #ffffff;
  text-align: left;
  padding: 18px 20px;
  cursor: pointer;
  font-family: 'Gilory-Semi';

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: #eef4f8;
  }
`;

const SupportActionTitle = styled.div`
  font-size: 19px;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #0f2530;
`;

const MemberDetailedView = (props) => {
    const [isAccountDataExporting, setIsAccountDataExporting] = useState(false)
    const accountDataExportRequestedRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [profile, setProfile] = useState({});
    const [displyFeedView, setDisplyFeedView] = useState(false);
    const [displayProfileStateModal, setDisplayProfileStateModal] = useState(false);
    const [displayLocationHistoryModal, setDisplayLocationHistoryModal] = useState(false);
    const [disaplyDeviceInfoModal, setDisaplyDeviceInfoModal] = useState(false);
    const [displayProfileLogHistoryModal, setDisplayProfileLogHistoryModal] = useState(false);
    const [displayImageHistoryModal, setDisplayImageHistoryModal] = useState(false);
    const [displayActivityModal, setDisplayActivityModal] = useState(false);
    const [params, setParams] = useState({});
    const [displayMessageModal, setDisplayMessageModal] = useState(false);
    const [displayMessage, setDisplayMessage] = useState(false);
    const [displayTransferSubModal, setDisplayTransferSubModal] = useState(false);
    const [displayInvoicesModal, setDisplayInvoicesModal] = useState(false);
    const [displayOfflineInvoicesModal, setDisplayOfflineInvoicesModal] = useState(false);
    const [displayInvitesModal, setDisplayInvitesModal] = useState(false);
    const [otherUserRef, setOtherUserRef] = useState('');
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);
    const [isSelfieVerified, setIsSelfieVerified] = useState("No");
    const [connectionsPage, setConnectionsPage] = useState(1);
    const [dislayCaptureGooglePaymentModal, setDislayCaptureGooglePaymentModal] = useState(false);
    const [displayIncognitoHistoryModal, setDisplayIncognitoHistoryModal] = useState(false);
    const [displayBoostHistoryModal, setDisplayBoostHistoryModal] = useState(false);
    const [displaySparkPurchaseHistoryModal, setDisplaySparkPurchaseHistoryModal] = useState(false);
    const [displayCuratorLogHistoryModal, setDisplayCuratorLogHistoryModal] = useState(false);
    const accessLevel = localStorage.getItem('accessLevel');
    const appName = localStorage.getItem('appName');
    const [modalText, setModalText] = useState('Transfer to REF ID');
    const [displaySubscriptionsModal, setDisplaySubscriptionsModal] = useState(false);
    const [displaySupportActionsMenu, setDisplaySupportActionsMenu] = useState(false);
    const [displayExtendSubscriptionModal, setDisplayExtendSubscriptionModal] = useState(false);
    const [displayMoneyBackGuaranteeModal, setDisplayMoneyBackGuaranteeModal] = useState(false);
    const supportActionsRef = useRef(null);
    const isMbgUser = Boolean(
        profile.money_back_guarantee && Object.keys(profile.money_back_guarantee).length > 0
    );
    const sparkPurchaseUsed = Math.max(
        (profile.sparks_details?.sparks_purchased || 0) -
        (profile.sparks_details?.purchased_sparks_left || 0) -
        (profile.sparks_details?.sparks_expired || 0),
        0
    );
    const isVernacsApp = ['Arike', 'Anbe', 'HeyDil', 'Neetho', 'Neene'].includes(appName);
    const inviteLabel = appName === 'Aisle' ? 'Comments' : isVernacsApp ? 'Notes' : 'Invites';

    const getEvenUrl = (event) => {
        const eventUrls = {
            capturePayment: urls.CAPTURE_PAYMENTS,
            updateLocation: urls.LOCATION_UPDATE,
            transferSubscription: urls.TRANSFER_SUBSCRIPTION,
            enableExclusivity: urls.ENABLE_EXCLUSIVITY
        }
        return eventUrls[event];
    }

    const getConnections = async () => {
        if (!profile.connections) {
            return
        }
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.GET_CONNECTIONS, { ref: props.detailedViewRef, page: connectionsPage })
        if (response.status) {
            let newConnections = [...profile.connections.connected_profiles, ...response.data.connected_profiles]
            setProfile({ ...profile, connections: { ...profile.connections, connected_profiles: newConnections } })
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getConnections();
    }, [connectionsPage]);

    const verifySelfie = async (type) => {
        let url = type === 'verify' ? urls.MARK_SELFIE_VERIFIED : urls.MARK_SELFIE_UNVERIFIED
        setIsLoading(true)
        let response = await authorizedHttpPost(url, { ref: profile.profile_data.ref })
        if (response.status) {
            type === 'verify' ? setIsSelfieVerified("Yes") : setIsSelfieVerified("No")
        }
        setIsLoading(false)
        setDisplaySelfieModal(false)
    }

    const handleDownload = async () => {
        setIsLoading(true)
        try {
            const response = await authorizedHttpGet(urls.DOWNLOAD_PROFILE, { ref: profile.profile_data.ref })
            if (response.status) {
                const jsonBlob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' });
                const url = URL.createObjectURL(jsonBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `profile_${profile.profile_data.ref}.json`;
                try {
                    a.click();
                } finally {
                    URL.revokeObjectURL(url);
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    const handleAccountDataDownload = async () => {
        const memberRef = profile.profile_data.ref;
        if (accountDataExportRequestedRef.current === memberRef) {
            return;
        }

        accountDataExportRequestedRef.current = memberRef;
        setIsAccountDataExporting(true)
        let response = await authorizedHttpGet(
            urls.DOWNLOAD_ACCOUNT_DATA,
            { ref: memberRef }
        )
        if (!response.status) {
            accountDataExportRequestedRef.current = null;
            setIsAccountDataExporting(false)
            alert('Unable to start account data export')
            return
        }

        alert(response.data.reused
            ? 'This export is already being prepared or was recently sent. Please check your email.'
            : 'The account data export is being prepared. You will receive an email when it is ready.'
        )
    }

    const handleButtonEvents = async (buttonEvent, newUserRef) => {
        setIsLoading(true)
        let response = await authorizedHttpPost(getEvenUrl(buttonEvent), { ref: profile.profile_data.ref, new_user_ref: newUserRef, old_user_ref: profile.profile_data.ref })
        if (response.status) {
            if (buttonEvent !== 'updateLocation') {
                setDisplayMessage(response.data.message)
                setDisplayMessageModal(true)

            }
            getProfileDetails();
        }
        setIsLoading(false)
    }

    const getProfileDetails = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.GET_MEMBER_FULL_PROFILE, { ref: props.detailedViewRef })
        if (response.status) {
            setIsSelfieVerified(response.data.verification_status.message)
            setProfile({
                ...response.data,
                report_count: response.data.report_info?.reports || 0
            });
        }
        setIsLoading(false)
    }
    useEffect(() => {
        getProfileDetails();
    }, []);

    useEffect(() => {
        accountDataExportRequestedRef.current = null;
        setIsAccountDataExporting(false);
    }, [props.detailedViewRef]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!supportActionsRef.current) {
                return;
            }

            if (!supportActionsRef.current.contains(event.target)) {
                setDisplaySupportActionsMenu(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const afterSave = async () => {
        await getProfileDetails();
    }

    const handleFeedView = () => {
        setDisplyFeedView(true)
        localStorage.setItem('detailViewRef', profile.profile_data.ref)
    }

    const closeFeedView = () => {
        setDisplyFeedView(false)
        localStorage.removeItem('detailViewRef')
    }

    const closeModal = () => {
        setDisplayProfileStateModal(false)
        setDisplayActivityModal(false)
        setDisplayMessageModal(false)
        setDisplayTransferSubModal(false)
        setDisplayInvoicesModal(false)
        setDisplayInvitesModal(false)
        setDislayCaptureGooglePaymentModal(false)
        setDisaplyDeviceInfoModal(false)
        setDisplayLocationHistoryModal(false)
        setDisplayOfflineInvoicesModal(false)
        setDisplayMoneyBackGuaranteeModal(false)
    }

    const toggleActivityModal = (filter, title) => {
        setParams({ filter: filter, title: title })
        setDisplayActivityModal(true)
    }

    const handleInvoicesModal = async () => {
        await getProfileDetails();
        closeModal();
    }

    const captureGooglePayment = async (productId, purchaseToken) => {
        setIsLoading(true)
        if (!productId || !purchaseToken) {
            alert('Please enter both Product ID and Purchase Token')
            return
        }
        var params = {
            ref: profile.profile_data.ref,
            product_id: productId,
            purchase_token: purchaseToken
        };
        var url = urls.CAPTURE_GOOGLE_PAYMENTS;
        var response = await authorizedHttpPost(url, params);
        if (response.status) {
            setDislayCaptureGooglePaymentModal(false)
            setDisplayMessage(response.data.message)
            setDisplayMessageModal(true)
        }
        setIsLoading(false)
    }

    const fetchCuratorLogs = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.FETCH_CURATOR_LOGS, { page: "1" })
        console.log(response)
        if (response.status) {
            setDisplayProfileLogHistoryModal(true)
        }
        setIsLoading(false)
    }

    const updateModalText = (text) => {
        setModalText(text)
    }

    const transferSubscriptionOnClick = () => {
        updateModalText('Transfer to REF ID')
        setDisplayTransferSubModal(true)
    }

    const addExclusivityOnClick = () => {
        updateModalText('Add exclusivity to REF ID')
        setDisplayTransferSubModal(true)
    }

    const cancelPhonepeAutopay = async () => {
        setIsLoading(true)
        const response = await authorizedHttpPost(urls.CANCEL_SUBSCRIPTION, {
            ref: profile.profile_data.ref,
            app_name: localStorage.getItem('appName')
        })
        if (response.status) {
            setDisplayMessage('PhonePe autopay cancelled successfully')
            setDisplayMessageModal(true)
        } else {
            setDisplayMessage('Unable to cancel PhonePe autopay')
            setDisplayMessageModal(true)
        }
        setIsLoading(false)
    }

    const handleSupportAction = (actionKey) => {
        setDisplaySupportActionsMenu(false);
        if (actionKey === 'capturePayment') {
            handleButtonEvents('capturePayment', profile.profile_data.ref);
        } else if (actionKey === 'updateLocation') {
            handleButtonEvents('updateLocation', profile.profile_data.ref);
        } else if (actionKey === 'transferSubscription') {
            transferSubscriptionOnClick();
        } else if (actionKey === 'gPlayCapture') {
            setDislayCaptureGooglePaymentModal(true);
        } else if (actionKey === 'enableExclusivity') {
            addExclusivityOnClick();
        } else if (actionKey === 'extendSubscriptionDays') {
            setDisplayExtendSubscriptionModal(true);
        } else if (actionKey === 'cancelPhonepeAutopay') {
            cancelPhonepeAutopay();
        } else if (actionKey === 'moneyBackGuarantee') {
            setDisplayMoneyBackGuaranteeModal(true);
        }
    }

    const supportActions = [
        capturePaymentPermission.includes(accessLevel) ? {
            key: 'capturePayment',
            title: 'Capture Payments'
        } : null,
        {
            key: 'updateLocation',
            title: 'Update Location'
        },
        gPlayAndSubTransferPermission.includes(accessLevel) ? {
            key: 'transferSubscription',
            title: 'Transfer Subscription'
        } : null,
        gPlayAndSubTransferPermission.includes(accessLevel) ? {
            key: 'gPlayCapture',
            title: 'G Play Capture'
        } : null,
        gPlayAndSubTransferPermission.includes(accessLevel) ? {
            key: 'extendSubscriptionDays',
            title: 'Extend Subscription Days'
        } : null,
        gPlayAndSubTransferPermission.includes(accessLevel) ? {
            key: 'cancelPhonepeAutopay',
            title: 'Cancel PhonePe Autopay'
        } : null,
        {
            key: 'moneyBackGuarantee',
            title: 'Money Back Guarantee'
        },
        capturePaymentPermission.includes(accessLevel) ? {
            key: 'enableExclusivity',
            title: 'Enable Exclusivity'
        } : null
    ].filter(Boolean);

    const currentProfileState = profile.profile_data?.profile_state
        ?.split(',')[0]
        .trim()
        .toLowerCase();
    const hideModerationActions = currentProfileState === 'pending_not_verified';

    return displyFeedView ? (
        <FeedDetailedProfileView
            closeDetailedView={closeFeedView}
            afterSave={afterSave}
            hideModerationActions={hideModerationActions}
        />
    ) : (
        <div className="marginLeft200">
            {displayMessageModal ? <MessageModal closeModal={closeModal} message={displayMessage} /> : null}
            {displayProfileStateModal ? <ProfileStateListModal closeModal={closeModal} profile={profile} /> : null}
            {displayProfileLogHistoryModal ? <ProfileLogHistoryListModal closeModal={closeModal} profile={profile} /> : null}
            {displayLocationHistoryModal ? <LocationHistoryModal closeModal={closeModal} profile={profile} /> : null}
            {disaplyDeviceInfoModal ? <DeviceInfoModal closeModal={closeModal} profile={profile} /> : null}
            {displayActivityModal ? <ActivityModal closeModal={closeModal} filter={params.filter} user_ref={profile.profile_data.ref} title={params.title} /> : null}
            {displayTransferSubModal ? <TransferSubModal closeModal={() => setDisplayTransferSubModal(false)} handleButtonEvents={handleButtonEvents} modalText={modalText} /> : null}
            {displayInvoicesModal ? <InvoicesModal closeModal={() => handleInvoicesModal()} payments={profile.invoices.payments_list} detailedViewRef={props.detailedViewRef} hasActivePhonepeSubscription={profile.invoices.has_active_phonepe_subscription} /> : null}
            {displayInvitesModal ? <InvitesModal closeModal={() => setDisplayInvitesModal(false)} other_user_ref={otherUserRef} current_user_ref={props.detailedViewRef} /> : null}
            {displaySelfieModal ? <VerifyModal closeModal={() => setDisplaySelfieModal(false)} image={profile.verification_status.selfie_url} verify={verifySelfie} /> : null}
            {dislayCaptureGooglePaymentModal ? <CaptureGooglePaymentModal closeModal={closeModal} captureGooglePayment={captureGooglePayment} /> : null}
            {displayOfflineInvoicesModal ? <OfflineInvoicesModal closeModal={() => handleInvoicesModal()} payments={profile.offline_invoices} detailedViewRef={props.detailedViewRef} /> : null}
            {displayImageHistoryModal ? <ImageHistoryModal closeModal={() => setDisplayImageHistoryModal(false)} userRef={profile.profile_data.ref} display={displayImageHistoryModal} /> : null}
            {displayIncognitoHistoryModal ? <IncognitoHistoryModal closeModal={() => setDisplayIncognitoHistoryModal(false)} userRef={profile.profile_data.ref} display={displayIncognitoHistoryModal} /> : null}
            {displayBoostHistoryModal ? <BoostHistoryModal closeModal={() => setDisplayBoostHistoryModal(false)} userRef={profile.profile_data.ref} display={displayBoostHistoryModal} /> : null}
            {displaySparkPurchaseHistoryModal ? <SparkPurchaseHistoryModal closeModal={() => setDisplaySparkPurchaseHistoryModal(false)} userRef={profile.profile_data.ref} display={displaySparkPurchaseHistoryModal} /> : null}
            {displayCuratorLogHistoryModal ? <CuratorLogHistoryModal closeModal={() => setDisplayCuratorLogHistoryModal(false)} userRef={profile.profile_data.ref} display={displayCuratorLogHistoryModal} /> : null}
            {displaySubscriptionsModal ? <SubscriptionsModal closeModal={() => setDisplaySubscriptionsModal(false)} userRef={props.detailedViewRef} /> : null}
            {displayMoneyBackGuaranteeModal ? <MoneyBackGuaranteeModal closeModal={() => setDisplayMoneyBackGuaranteeModal(false)} userRef={props.detailedViewRef} /> : null}
            {displayExtendSubscriptionModal ? (
                <ExtendSubscriptionModal
                    closeModal={() => setDisplayExtendSubscriptionModal(false)}
                    userRef={props.detailedViewRef}
                    onSuccess={(message) => {
                        setDisplayMessage(message)
                        setDisplayMessageModal(true)
                        getProfileDetails()
                    }}
                    onError={(message) => {
                        setDisplayMessage(message)
                        setDisplayMessageModal(true)
                    }}
                />
            ) : null}
            {isLoading ? <Loader /> : null}

            <span className="sideNavCloseButton" onClick={() => props.closeDetailedView()} >
                &times;
            </span>
            <div className="buttonDivDetailedView">
                {supportActions.length > 0 && (
                    <SupportActionsWrapper ref={supportActionsRef}>
                        <SupportActionsButton onClick={() => setDisplaySupportActionsMenu(!displaySupportActionsMenu)}>
                            Support Actions
                        </SupportActionsButton>
                        {displaySupportActionsMenu && (
                            <SupportActionsMenu>
                                {supportActions.map((action) => (
                                    <SupportActionItem key={action.key} onClick={() => handleSupportAction(action.key)}>
                                        <SupportActionTitle>{action.title}</SupportActionTitle>
                                    </SupportActionItem>
                                ))}
                            </SupportActionsMenu>
                        )}
                    </SupportActionsWrapper>
                )}
                {['Admin', 'Manager'].includes(accessLevel) && profile && profile.profile_data ? (
                    <DownloadAccountDataButton
                        onClick={handleAccountDataDownload}
                        disabled={isAccountDataExporting}
                    >
                        {isAccountDataExporting ? 'Account Data Requested' : 'Download Account Data'}
                    </DownloadAccountDataButton>
                ) : null}
            </div>

            {
                (profile && profile.profile_data) ? (
                    <FlexWrapper>
                        <ImageDivView
                            height={false ? '365px' : null}
                            src={profile.profile_data.avatar}
                            onError={e => {
                                e.target.src = placeholder_image;
                            }}
                            is_end
                        />
                        <GapView width="58px" />
                        <div>
                            <FlexWrapper>
                                <InfoDiv>
                                    <InfoText cursor onClick={() => handleFeedView()}>
                                        {profile.profile_data.name}
                                        <br />
                                        {profile.profile_data.gender[0]} /{' '}
                                        {profile.profile_data.age}
                                        <br />
                                        {profile.profile_data.ref}
                                        <br />
                                    </InfoText>
                                    <InfoText cursor
                                        onClick={() => {
                                            setDisplayLocationHistoryModal(true)
                                        }}
                                    >
                                        {profile.profile_data.location_str}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText
                                        cursor
                                        onClick={() => {
                                            setDisplayProfileStateModal(true)
                                        }}
                                    >
                                        Status: {profile.profile_data.profile_state}
                                        {(() => {
                                            const curator = (profile.state_history_list && profile.state_history_list.length > 0 && profile.state_history_list[0].curator);
                                            const status = profile.profile_data.profile_state?.toString().toUpperCase();
                                            // Only show curator if it's not already included in profile_state and status is curator-driven
                                            if (curator && !profile.profile_data.profile_state.includes(curator) && ['APPROVED', 'DISAPPROVED', 'IMAGE_INAPPROPRIATE'].includes(status)) {
                                                return (
                                                    <span style={{marginLeft: '10px', fontWeight: 'bold', color: 'black'}}>
                                                        ({curator})
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Dates <br />
                                    </InfoText>
                                    <InfoText>
                                        Joined: {profile.profile_data.joined ? getDateWithTime(profile.profile_data.joined) : null}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Submitted:{' '}
                                        {profile.profile_data.application_date ? getDateWithTime(profile.profile_data.application_date) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Approved:{' '}
                                        {profile.profile_data.approved_date ? getDateWithTime(profile.profile_data.approved_date) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Deleted: {profile.profile_data.deleted ? getDateWithTime(profile.profile_data.deleted) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Deleted by: {profile.deleted_by ? profile.deleted_by : ''}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Last Login: {profile.profile_data.last_login ? getDateWithTime(profile.profile_data.last_login) : null}
                                    </InfoText>{' '}
                                    <br />
                                    <InfoText>
                                        Last Seen:{' '}
                                        {profile.profile_data.last_seen_window ? getDateWithTime(profile.profile_data.last_seen_window) : null}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Last Img Update: {profile.profile_data.last_image_update_by}
                                    </InfoText>
                                    <br/>
                                    <InfoText>
                                        Last Img Updated date: {safeGetDateWithTime(profile.profile_data.last_image_update_at)}
                                    </InfoText>
                                    <br/>
                                    <InfoText>
                                        Auto feed Checked by: {profile.profile_data.auto_feed_checked_by}
                                    </InfoText>
                                    <br/>
                                    <InfoText>
                                        Auto feed Checked at: {safeGetDateWithTime(profile.profile_data.auto_feed_checked_at)}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>Contact</InfoText>
                                    <br />
                                    <InfoText>{profile.profile_data.personal_email}</InfoText>
                                    <br />
                                    <InfoText>
                                        {profile.profile_data.phone_code}
                                        {profile.profile_data.mobile_number}
                                    </InfoText>
                                    <br />
                                    <InfoText>User Id: {profile.profile_data.user_id}</InfoText>
                                    <br />
                                    <InfoText>Device Id: {profile.profile_data.unique_identifier}</InfoText>
                                    <br />
                                    <InfoText>Incognito On: {profile.incognito ? "Yes" : "No"}</InfoText>
                                    <br />
                                    <br />
                                    <div onClick={() => {
                                        setDisaplyDeviceInfoModal(true)
                                    }} style={{ cursor: "pointer" }}>
                                        <InfoText>Device: {profile.profile_data.device_type}</InfoText>
                                        <br />
                                        <InfoText>Model: {profile.profile_data.model_details}</InfoText>
                                        <br />
                                        <InfoText>OS Version: {profile.profile_data.os_version}</InfoText>
                                        <br />
                                        <InfoText>
                                            App Version:{profile.profile_data.app_version}
                                        </InfoText>
                                    </div>

                                </InfoDiv>
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="15px" />
                            <FlexWrapper>
                                {profile.likes_details ? (
                                    <InfoDiv>
                                        <InfoText>
                                            Likes Left: {profile.likes_details.likes_left}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('likes_sent', 'Likes Sent')}
                                        >
                                            Likes Sent: {profile.likes_details.likes_sent}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_passed', 'Likes Passed')

                                            }
                                        >
                                            Likes Passed: {profile.likes_details.likes_passed}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('likes_received', 'Likes Received')
                                            }
                                        >
                                            Likes Received: {profile.likes_details.likes_received}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_connection', 'Likes Connection')
                                            }
                                        >
                                            Likes Connections:{' '}
                                            {profile.likes_details.likes_connection}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() =>
                                                toggleActivityModal('likes_linked', 'Likes Linked')
                                            }
                                        >
                                            Likes Linked: {profile.likes_details.likes_linked}
                                        </InfoText>
                                    </InfoDiv>
                                ) : (
                                    <InfoDiv></InfoDiv>
                                )}
                                <GapView width="58px" />
                                {profile.sparks_details ? (
                                    <InfoDiv>
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_sent', 'Sparks Sent')}
                                        >
                                            Sparks Sent: {profile.sparks_details.sparks_sent}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_sent_accepted', 'Sparks Sent Accepted')}
                                        >
                                            Sparks Sent Accepted: {profile.sparks_details.sparks_sent_accepted || 0}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_sent_rejected', 'Sparks Sent Rejected')}
                                        >
                                            Sparks Sent Rejected: {profile.sparks_details.sparks_sent_rejected || 0}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_received', 'Sparks Received')}
                                        >
                                            Sparks Received: {profile.sparks_details.sparks_received}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_received_accepted', 'Sparks Received Accepted')}
                                        >
                                            Sparks Received Accepted: {profile.sparks_details.sparks_received_accepted || 0}
                                        </InfoText>
                                        <br />
                                        <InfoText
                                            cursor
                                            onClick={() => toggleActivityModal('sparks_received_rejected', 'Sparks Received Rejected')}
                                        >
                                            Sparks Received Rejected: {profile.sparks_details.sparks_received_rejected || 0}
                                        </InfoText>
                                    </InfoDiv>
                                ) : (
                                    <InfoDiv></InfoDiv>
                                )}
                            </FlexWrapper>
                            <GapView height="15px" />
                            <LineView width="724px" />
                            <GapView height="15px" />
                            <FlexWrapper>
                                <InfoDiv>
                                    <InfoText>
                                        {inviteLabel} Left: {profile.invites_details.invites_left}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent', `${inviteLabel} Sent`)
                                        }
                                    >
                                        {inviteLabel} Sent: {profile.invites_details.invites_sent}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent_accepted', `${inviteLabel} Sent Accepted`)
                                        }
                                    >
                                        {inviteLabel} Sent Accepted:{' '}
                                        {profile.invites_details.sent_accepted_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received_accepted', `${inviteLabel} Received Accepted`)
                                        }
                                    >
                                        {inviteLabel} Received Accepted:{' '}
                                        {profile.invites_details.received_accepted_requests}
                                    </InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received', `${inviteLabel} Received`)
                                        }
                                    >
                                        {inviteLabel} Received: {profile.invites_details.invites_received}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_sent_passed', `${inviteLabel} Sent Passed`)
                                        }
                                    >
                                        {inviteLabel} Sent Passed:{' '}
                                        {profile.invites_details.sent_declined_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('invites_received_passed', `${inviteLabel} Received Passed`)
                                        }
                                    >
                                        {inviteLabel} Received Passed:{' '}
                                        {profile.invites_details.received_declined_requests}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('user_passed', 'User Passed')
                                        }
                                    >
                                        User Passed: {profile.invites_details.pass_count}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Was Passed:{profile.invites_details.passed_by_others}
                                    </InfoText>
                                </InfoDiv>
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="30px" />
                            <FlexWrapper>
                                <InfoDiv>
                                    <InfoText>
                                        Subscription:{' '}
                                        {profile.profile_data.active_plan_type == null
                                            ? 'Not Active'
                                            : profile.profile_data.active_plan_type}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Auto Phonepe Active:{' '}
                                        {profile.invoices.has_active_phonepe_subscription ? 'Yes' : 'No'}                  
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        F4F: {profile.profile_data.is_free_for_female ? 'True' : 'False'}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={invoiceModalAccess.includes(accessLevel) ? () => setDisplayInvoicesModal(true) : null}
                                    >
                                        Online Invoices: {profile.invoices.total_payments}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={invoiceModalAccess.includes(accessLevel) ? () => setDisplayOfflineInvoicesModal(true) : null}
                                    >
                                        Offline Invoices: {profile.offline_invoices ? profile.offline_invoices.length : 0}
                                    </InfoText>
                                    <br />
                                    {isMbgUser ? <MbgUserLabel>MBG USER</MbgUserLabel> : null}
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>
                                        Message received: {profile.messages_count.received}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Messages sent:{profile.messages_count.sent}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Rooms:{profile.is_room_active ? 'Active' : 'Inactive'}
                                    </InfoText>
                                    <br />
                                    <InfoText>

                                        Selfie Verified: {isSelfieVerified}
                                    </InfoText>
                                    <br />
                                    { profile.verification_status.verified_time != null && (
                                        <InfoText>
                                        Selfie Verified Time: {profile.verification_status.verified_time ? getDateWithTime(profile.verification_status.verified_time) : null}
                                        </InfoText>
                                    )}
                                    {profile.verification_status.selfie_url ? (
                                        <div>
                                            <InfoText cursor onClick={accessLevel === 'Admin' || accessLevel === 'Associate' || accessLevel === 'SupportAssociate' || accessLevel === 'Manager' ? () => setDisplaySelfieModal(true) : null}>
                                                Selfie Url
                                            </InfoText>
                                        </div>
                                    ) : null}
                                    <InfoText>Rating:{profile.rating}</InfoText>
                                    <br />
                                    <InfoText>Mean Score:{profile.mean_rating}</InfoText>
                                </InfoDiv>
                                <GapView width="58px" />
                                <InfoDiv>
                                    <InfoText>Comments:{profile.comments}</InfoText>
                                    <br />
                                    <InfoText>
                                        Warnings:{profile.profile_data.email_sent_count}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('blocked_self', 'Blocked')
                                        }
                                    >
                                        Blocks:{profile.block_info.blocks}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() =>
                                            toggleActivityModal('blocked_by', 'Blocked By')
                                        }
                                    >
                                        Blocked By:{profile.block_info.blocked_by}
                                    </InfoText>
                                    <br />
                                    <InfoText
                                        cursor
                                        onClick={() => toggleActivityModal('reports', 'Report Count')}
                                    >
                                        Report Count:{profile.report_count || 0}
                                    </InfoText>
                                    <br />
                                    <InfoText>
                                        Connections:{profile.connections.active_connections}
                                    </InfoText>
                                    {profile.boost_info ? (
                                        <>
                                            <br />
                                            <MetricText>
                                                Boost purchased: {profile.boost_info.boost_purchased}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Boost used: {profile.boost_info.boost_used}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Boost left: {profile.boost_info.boost_left}
                                            </MetricText>
                                            <br />
                                        </>
                                    ) : null}
                                    {profile.sparks_details ? (
                                        <>
                                            <br />
                                            <MetricText>
                                                Sparks purchased: {profile.sparks_details.sparks_purchased}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Sparks used: {sparkPurchaseUsed}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Sparks left: {profile.sparks_details.purchased_sparks_left}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Daily Free Sparks left: {profile.sparks_details.daily_free_sparks_left}
                                            </MetricText>
                                            <br />
                                            <MetricText>
                                                Sparks Expired: {profile.sparks_details.sparks_expired}
                                            </MetricText>
                                            <br />
                                        </>
                                    ) : null}
                                </InfoDiv>
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="15px" />
                            <FlexWrapper>
                                <HistoryBox onClick={() => setDisplayImageHistoryModal(true)}>
                                    Image History
                                </HistoryBox>
                                <GapView width="150px" />
                                <IncognitoHistoryBox onClick={() => setDisplayIncognitoHistoryModal(true)}>
                                    Incognito History
                                </IncognitoHistoryBox>
                                <GapView width="150px" />
                                <CuratorLogHistoryBox onClick={() => setDisplayCuratorLogHistoryModal(true)}>
                                    Curator Log History
                                </CuratorLogHistoryBox>
                            </FlexWrapper>
                            <GapView height="50px" />
                            <FlexWrapper>
                                <BoostHistoryBox onClick={() => setDisplayBoostHistoryModal(true)}>
                                    Boost History
                                </BoostHistoryBox>
                                <GapView width="115px" />
                                <BoostHistoryBox onClick={() => setDisplaySparkPurchaseHistoryModal(true)}>
                                    Spark Purchase History
                                </BoostHistoryBox>
                                {(gPlayAndSubTransferPermission.includes(accessLevel)) && (
                                    <>
                                        <GapView width="115px" />
                                        <BoostHistoryBox onClick={() => setDisplaySubscriptionsModal(true)}>
                                            Subscription History
                                        </BoostHistoryBox>
                                    </>
                                )}
                            </FlexWrapper>
                            <GapView height="30px" />
                            <LineView width="724px" />
                            <GapView height="15px" />
                            <FlexBottom>
                                {profile.connections.connected_profiles.map(item => {
                                    return (
                                        <ConnectedDiv
                                            key={item.ref}
                                            onClick={() => {
                                                setDisplayInvitesModal(true);
                                                setOtherUserRef(item.ref);
                                            }}
                                        >
                                            <div>
                                                <ImageCirlceView src={item.avatar} />
                                            </div>
                                            <FlexWrapper>
                                                <GapView width="15px" />
                                                <InfoText>
                                                    {item.first_name}
                                                    <br />
                                                    {item.ref}
                                                    <br />
                                                    Sent:{item.messages_sent}
                                                    <br />
                                                    Recieved: {item.messages_received}
                                                </InfoText>
                                            </FlexWrapper>
                                        </ConnectedDiv>
                                    );
                                })}

                            </FlexBottom>

                            {isLoading ? (
                                <Loader />
                            ) : profile.connections.total_pages > connectionsPage ? (
                                <BottomButtonBase
                                    onClick={() =>
                                        setConnectionsPage(connectionsPage + 1)
                                    }
                                >
                                    Load More
                                </BottomButtonBase>
                            ) : null}
                            <GapView height="30px" />
                            <BaseButton onClick={handleDownload} disabled={isLoading}>
                                Download
                            </BaseButton>
                        </div>
                    </FlexWrapper>
                ) : null
            }
        </div>
    );
};

export default MemberDetailedView;
